import { createContext, ReactNode, RefObject, useRef } from "react";

interface TextfieldContextValues {
  textFieldRef: RefObject<HTMLInputElement | undefined> | undefined;
}

export const TextFieldContext = createContext<TextfieldContextValues>({
  textFieldRef: undefined,
});

interface Props {
  children: ReactNode;
}

export function TextFieldContextProvider(props: Props) {
  const { children } = props;
  const textFieldRef = useRef<HTMLInputElement | undefined>();

  return (
    <TextFieldContext.Provider value={{ textFieldRef: textFieldRef }}>
      {children}
    </TextFieldContext.Provider>
  );
}
